export const environment = {
    production: true,
    api_base_url: 'https://member-sub-client-api.goori.tech',
    // api_base_url: 'https://admin-api.goori.tech',
    // web_socket_url: 'ws://localhost:8090',
    // web_socket_url: 'ws://128.199.191.104:8090',
    web_socket_url: 'wss://ws-admin.goori.tech',
    google_maps_api_key: 'AIzaSyCXc2QVEFuge2cn9WP2CftMQZuCj21lzx4'
};
